import {
  GritOverlayFooterDirective,
  GritOverlayTitleDirective,
} from './grit-overlay-content-directives';
import { GritOverlay } from '../grit-overlay';
import {
  Component,
  OnInit,
  HostBinding,
  Input,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  ContentChild,
  NgZone,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { OverlayType } from '../grit-overlay-config';
import { Subscription } from 'rxjs';

@Component({
  selector: 'grit-overlay-content-container',
  templateUrl: './grit-overlay-content.component.html',
  styleUrls: ['./grit-overlay-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OverlayContentComponent implements OnInit, AfterViewInit {
  @ContentChild(GritOverlayFooterDirective, { static: false })
  footer: GritOverlayFooterDirective;
  @ContentChild(GritOverlayTitleDirective, { static: false })
  title: GritOverlayTitleDirective;
  @ViewChild('bodyContent', { static: true }) _bodyContent: ElementRef;
  @HostBinding('class.grit-overlay-content-container') contentClass = true;

  get footerSticky() {
    return this._isFooterSticky;
  }

  set footerSticky(sticky) {
    this._isFooterSticky = sticky;
  }

  @Input('showCloseIcon') get showCloseIcon(): boolean {
    return this._showCloseIcon;
  }

  set showCloseIcon(isShowCloseIcon: boolean) {
    this._showCloseIcon = isShowCloseIcon;
  }

  _isFooterSticky;

  _overlayType: OverlayType;
  overlaySubscription: Subscription;
  _showCloseIcon: boolean;

  constructor(private _overlay: GritOverlay, private _renderer: Renderer2) {}

  ngOnInit() {
    this.overlaySubscription = this._overlay
      .getCurrentOverlayType()
      .subscribe(e => {
        this._overlayType = e;
      });
    if (this.showCloseIcon === null || this.showCloseIcon === undefined) {
      if (this._overlayType !== 'modal') {
        this.showCloseIcon = true;
      } else {
        this.showCloseIcon = false;
      }
    }
  }

  ngAfterViewInit() {
    if (this.footer && this.footer.sticky) {
      this._renderer.addClass(
        this._bodyContent.nativeElement,
        'grit-footer-is-sticky'
      );
    }
  }

  ngOnDestroy(): void {
    this.overlaySubscription.unsubscribe();
  }

  closeSheet() {
    this._overlay.closeAll();
  }
}
